import { useEffect, useState } from "react";
import { getTaskCount } from "apps/journeys/utils/api-requests/home-page";
import { useIdentity } from "base/identity-resolver";
import { Loading } from "@evertrue/et-components";
import TaskCount from "../../task-count/task-count";
import checkIcon from "images/check.svg";
import { PropTypes } from "base/react-libs";

const OtherTaskCounter = ({ reload = false, stopReload = () => {} }) => {
  const { user } = useIdentity();
  const [title, setTitle] = useState("");
  const [showIcon, setShowIcon] = useState(false);
  const [loading, setLoading] = useState(false);

  const [totals, setTotals] = useState({});
  const [data, setData] = useState({});

  useEffect(() => {
    const countTasks = async () => {
      const todayTime = new Date().getTime();
      setLoading(true);
      const taskCounts = await getTaskCount(todayTime, user.id, ["IN_PROGRESS"]);
      setLoading(false);
      const { completed, notEmailOrPhone, ...rest } = taskCounts;
      setData(taskCounts);
      setTotals(rest);
      stopReload();
    };

    countTasks();
  }, [user.id, reload, stopReload]);

  useEffect(() => {
    const { total } = totals;
    const { completed } = data;

    let newTitle = "";
    if (total === 0 && completed === 0) {
      newTitle = "You have no other tasks due";
      setShowIcon(false);
    } else if (total > 0) {
      newTitle = null;
      setShowIcon(false);
    } else {
      newTitle = "You completed all of your other tasks!";
      setShowIcon(true);
    }
    setTitle(newTitle);
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [totals.total]);

  if (loading) {
    return <Loading />;
  }

  return <TaskCount title={"Other Tasks"} subTitle={title} icon={checkIcon} showIcon={showIcon} data={totals} />;
};

OtherTaskCounter.propTypes = {
  reload: PropTypes.bool,
  stopReload: PropTypes.func,
};

export default OtherTaskCounter;
